import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1019420914588861');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-base text-main font-sans selection:bg-warm/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <RevelationSection data-id="element-5" />
        <ValueStack data-id="element-6" />
        <GuaranteeSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}